import { shortDate } from '../utils/formatters';

export const getFileName = (filename, appendDate = true, options = {}) => {
    let name = filename;

    if (appendDate) {
        name += `-${shortDate()}`;
    }

    if (options?.suffix) {
        name += options.suffix;
    }

    name += `.csv`;

    return name.replaceAll('/', '_');
};


const downloadCSV = (csv, filename, appendDate = true, options = {}) => {
    // Download link
    let downloadLink = document.createElement('a');
    downloadLink.download = getFileName(filename, appendDate, options);

    // Create a link to the file
    downloadLink.href = `data:text/csv;charset=utf-8,\uFEFF${encodeURIComponent(
        csv,
    )}`;

    // Hide download link
    downloadLink.style.display = 'none';

    // Add the link to DOM
    document.body.appendChild(downloadLink);

    // Click download link
    downloadLink.click();

    //Remove temp a tag after 1 second
    setTimeout(() => document.body.removeChild(downloadLink), 1000);
};

export default downloadCSV;
